import React from 'react';
import { GCMain, GCTitle, GCSubTitle, GCDescription } from './GraphContainerTablaDinamica.style';


import GraphMasterDynamic from '../GraphMasterDynamic/GraphMasterDynamic';
import MasterDynamicTable from '../MasterDynamicTable/MasterDynamicTable';
import SimpleModal from '../Modal';

const GraphContainerTablaDinamica = (props) => {
  let { data, type, title, subtitle, description, table } = props;
  
  console.log("TABLADINAMICA GRAPHCONTAINER", props)
  
  let getData = (info) => {
    if(info) {
      let arreglo = info.data ? info.data : info;
      let register = arreglo ? type === "Precios_Stats_Conteo" ? arreglo.find( element => element.name === "Precios_Stats") : arreglo.find( element => element.name === type) : []
      
      return table ? 
      (() => <MasterDynamicTable data={register} />)() 
      :
      (() => <GraphMasterDynamic data={register}/>)()
    } else console.log('no hay info');
  }

  return (
    <GCMain style={{width: props.wi, height: props.he, margin: "0 auto"}}>
      <SimpleModal data={{...data, type, title, subtitle, description}} />
      <GCTitle>{ title }</GCTitle>
      <GCSubTitle>{ subtitle }</GCSubTitle>
      {
        getData(data)
      }
    </GCMain>
  );
}

export default GraphContainerTablaDinamica;
